

export const categories = [
    {
        value: "All",
        position: 250
    },
    {
        value: "E-comm",
        position: 150
    },
    {
        value: "Landing",
        position: 50
    },
    {
        value: "Corporate",
        position: -50
    }
] 